import { useNavigate } from "react-router-dom";
import { Button, Modal, Typography } from "@/components/atoms";

interface CannotDeactivatePrivateNetworkModalProps {
  open: boolean;
  onClose: () => void;
}

export const CannotDeactivatePrivateNetworkModal = ({ open, onClose }: CannotDeactivatePrivateNetworkModalProps) => {
  const navigate = useNavigate();

  const handleGoToBookings = () => {
    onClose();
    navigate("/bookings");
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Can't Deactivate Private Network"
      variant="web-small"
      renderButtons={() => (
        <>
          <Button variant="tertiary" size="md" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" size="md" onClick={handleGoToBookings}>
            Go to Bookings
          </Button>
        </>
      )}
    >
      <div className="flex flex-col gap-3">
        <Typography variant="paragraph" className="text-neutral-dark-gray">
          You currently have upcoming jobs that have been offloaded to your private network partners.
        </Typography>
        <Typography variant="paragraph" className="text-neutral-dark-gray">
          {"To deactivate this add-on, you'll need to recall those jobs back to your operation first."}
        </Typography>
        <Typography variant="paragraph" className="text-neutral-dark-gray">
          Once all future offloaded jobs are recalled, you can deactivate Private Network.
        </Typography>
      </div>
    </Modal>
  );
};
